<template>
    <div class="criteria-input">
        <v-popper ref="conditionSearch" :auto-hide="false" style="display:block">
            <div slot="trigger">
                <r-input
                    ref="searchField"
                    left-icon="burger"
                    placeholder="Type to find fields"
                    v-popper-trigger
                    v-model="query"
                />
            </div>
            <div class="criteria-input-dropdown dropdown dropdown-fluid" slot="content">
                <template v-for="group in results">
                    <div class="dropdown-content dropdown-content-help text-left" :key="`${group.fullPath}_header`">
                        <group-header :lineage="group.fullPath"/>
                    </div>
                    <div class="dropdown-content" :key="`${group.fullPath}_menu`">
                        <div
                            v-for="field in group.fields"
                            :key="`${group.fullPath}_${field}`"
                            @click.stop="select(group.fullPath, field)"
                            class="dropdown-item">{{field | unCamelCase}}
                        </div>
                    </div>
                </template>
            </div>
        </v-popper>

    </div>
</template>

<script>
    import vPopper from '@/components/v-popper';
    import debounceMixin from '@/mixins/helpers/debounce-mixin';
    import GroupHeader from './criteria-input/group-header';
    import SearchProvider from './search-provider';

    export default {
        name: 'criteria-input',
        mixins: [debounceMixin],
        components: {vPopper, GroupHeader},
        props: {
            fieldProvider: Object,
        },
        data() {
            return {
                results: [],
                searchProvider: null,
            };
        },
        methods: {
            buildOptions() {
                this.searchProvider = new SearchProvider({fieldProvider: this.fieldProvider});
            },
            debouncedDelegate(query) {
                this.results = this.searchProvider.find(query);
            },
            resetDelegate() {
                this.results = [];
            },
            resetQuery() {
                this.query = null;
                this.results = [];
            },
            select(precursor, field) {
                this.$emit('select-field', this.searchProvider.getFieldDefinition({precursor, field}));
                this.resetQuery();
            },
        },
        created() {
            this.buildOptions();
        },
    };
</script>

<style scoped>

</style>
